import { useCurrentAssistant } from '@/hooks/useAssistantAuth';
import { Header } from '@/components/layout/Header';
import { NotificationSettings } from '@/components/settings/NotificationSettings';
import { LoadingSpinner } from '@/components/LoadingSpinner';
import { useTranslation } from 'react-i18next';

export default function AssistantSettings() {
  const { t } = useTranslation();
  const { data: assistant, isLoading } = useCurrentAssistant();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <Header />
        <main className="container mx-auto px-4 py-8 flex justify-center">
          <LoadingSpinner />
        </main>
      </div>
    );
  }

  if (!assistant) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <Header />
        <main className="container mx-auto px-4 py-8">
          <p className="text-muted-foreground text-center">
            {t('common.notAuthenticated', 'Not authenticated')}
          </p>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">
            {t('navigation.settings', 'Settings')}
          </h1>
          <p className="text-muted-foreground">
            {t('settings.assistantDescription', 'Manage your notification preferences')}
          </p>
        </div>

        <div className="max-w-2xl">
          <NotificationSettings
            restaurantId={assistant.restaurantId}
            assistantId={assistant.id}
          />
        </div>
      </main>
    </div>
  );
}
